type MarkProps = {
  variant?: "light" | "dark";
  size?: number;
  className?: string;
};

export default function Mark({ variant = "light", size = 24, className }: MarkProps) {
  const horizonClass = variant === "dark" ? "stroke-on-dark" : "stroke-ink-900";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <line
        x1={2}
        y1={19}
        x2={22}
        y2={19}
        strokeWidth={1.75}
        strokeLinecap="round"
        className={horizonClass}
      />
      <circle cx={12} cy={10} r={8} className="fill-sun" />
    </svg>
  );
}
